module.exports = "/images/mindaugas-visokinskas.jpg?8d4c0d773f4440dee60f01ac002d042d";